// Unveränderliche Korrespondenzen — und die daran hängenden Dokumente.
//
// Eine Nachricht, die an eine Schnittstelle gegangen ist, darf im Portal nachträglich nicht
// mehr verändert oder gelöscht werden: sonst weicht der Portal-Stand von dem ab, was beim
// Versicherer liegt. Bisher galt das nur für **GDV**; „PX Connect Nachricht" braucht dieselbe
// Sperre und ist deshalb hier mitaufgenommen.
//
// Gesperrt heißt: ansehen ja, bearbeiten nein, löschen nein — auch für die Anhänge.

/** Kürzel der Korrespondenz-Typ-Snippets, deren Nachrichten unveränderlich sind. */
export const LOCKED_CORRESPONDENCE_TYPES = ['GDV', 'PXC'];

export const isLockedCorrespondenceType = (kuerzel: unknown): boolean =>
    typeof kuerzel === 'string' && LOCKED_CORRESPONDENCE_TYPES.includes(kuerzel);

/**
 * Zeile der Korrespondenzliste. `typKuerzel` liefert der Resolver als Kürzel des
 * Typ-Snippets (`api/src/korrespondenz.ts`: `snippet.kuerzel AS typKuerzel`).
 */
export const isLockedCorrespondenceRow = (row: any): boolean =>
    isLockedCorrespondenceType(row?.original?.typKuerzel);

/**
 * Hängt das Dokument an mindestens einer gesperrten Korrespondenz? Dann ist auch das
 * Dokument gesperrt — es ist Teil einer bereits versendeten Nachricht.
 */
export const hasLockedCorrespondenceReference = (
    correspondenceDocument: { korrespondenz?: { typSnippet?: { kuerzel?: string | null } | null } | null }[] = []
): boolean =>
    (correspondenceDocument || []).some((corrDoc) =>
        isLockedCorrespondenceType(corrDoc?.korrespondenz?.typSnippet?.kuerzel)
    );
